import Api from "../Api";

export const RESTAURANTS_LOADED = '@app/restaurants/loaded';
export const RESTAURANTS_LOADING = '@app/restaurants/loading';
export const RESTAURANTS_ERROR = '@app/restaurants/error';
export const RESTAURANTS_POPULATED = '@app/restaurants/notFound';

const initialState = {
    items: {},
    language: null,
    error: false,
    loading: false,
    populated: false,
};

export const setErrorFlag = (value) => {
    return {
        type: RESTAURANTS_ERROR,
        value,
    }
};

export const setPopulatedFlag = (value) => {
    return {
        type: RESTAURANTS_POPULATED,
        value,
    }
};

export const setLoadingFlag = (value) => {
    return {
        type: RESTAURANTS_LOADING,
        value,
    }
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case RESTAURANTS_LOADED: {
            const items = state.language === action.language ? Object.assign({}, state.items) : {};

            for (let i = 0; i < action.items.length; i++) {
                items[action.items[i].id] = action.items[i];
            }
            return Object.assign({}, state, {
                items,
                language: action.language,
            });
        }
        case RESTAURANTS_ERROR: {
            return Object.assign({}, state, {error: action.value});
        }
        case RESTAURANTS_POPULATED: {
            return Object.assign({}, state, {populated: action.value});
        }
        case RESTAURANTS_LOADING: {
            return Object.assign({}, state, {loading: action.value});
        }
        default:
            return state;
    }
}

export const fetchRestaurants = () => (dispatch, getState) => {
    const state = getState();

    if (state.restaurants.populated && state.restaurants.language === state.app.language) {
        return;
    }

    dispatch(setErrorFlag(false));
    dispatch(setLoadingFlag(true));

    return Api.restaurants({'_lang': state.app.language, expand: 'menus, gallery'}).then((models) => {
        dispatch({
            type: RESTAURANTS_LOADED,
            items: models,
            language: state.app.language,
        });
        dispatch(setLoadingFlag(false));
        dispatch(setPopulatedFlag(true));
    }).catch(() => {
        dispatch(setErrorFlag(true));
        dispatch(setLoadingFlag(false));
    });
};

export function sortRestaurants(list) {
    return Object.values(list).sort((a, b) => {
        if (a.position > b.position) {
            return -1;
        } else if (a.position < b.position) {
            return 1;
        }

        return 0;
    });
}


// WEBPACK FOOTER //
// ./src/js/reducers/restaurants.js